module.exports = __webpack_public_path__ + "img/advantage1_1@2x.76284df4.png";